import { type SupportedWalletType } from '@pkg/types';

export const urls = {
    chain: {
        aptos: 'https://aptoslabs.com/',
        ethereum: 'https://ethereum.org/',
        polygon: 'https://polygon.technology/',
    },
    metamask: 'https://metamask.io/',
    // TODO: Consider showing this UI within the Sheet.
    connectWallet: '/wallet',
};

export const walletOptions: SupportedWalletType[] = ['walletConnect', 'metaMask', 'petra'];
